import React from 'react';
import MonetizationOnOutlined from '@mui/icons-material/MonetizationOnOutlined';
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import StatCard from '../StatCard'

const CardOrcamentosEnviados = (props) => {
  const orcamentosEnviados = useSelector((state) => state.dashboard?.dashboard?.orcamentosEnviados)

  return (
    <StatCard
      {...props}
      label="Propostas enviadas"
      value={orcamentosEnviados ? orcamentosEnviados : 0}
      icon={<MonetizationOnOutlined />}
    />
  );
}

CardOrcamentosEnviados.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default CardOrcamentosEnviados
